import React from 'react';
import { Helmet } from 'react-helmet-async';
import whatsappGroups from '@/config/whatsappGroups';
import LinkTreeCard from '@/components/LinkTreeCard';
import { MessageCircle } from 'lucide-react';

export default function JoinPage() {
  return (
    <main className="min-h-screen w-full flex items-center justify-center gradient-turquoise-dark">
      <Helmet>
        <title>Join Our WhatsApp Groups</title>
        <meta
          name="description"
          content="Official WhatsApp groups for Janet Marketing Training. Select your preferred group and join instantly."
        />
      </Helmet>

      <div className="absolute inset-0 pointer-events-none shadow-glow opacity-30" />

      <section className="z-10 w-full max-w-4xl px-6 py-20 flex items-center justify-center">
        <div className="glass-card rounded-2xl p-6 md:p-10 w-full animate-slide-up animate-scale-in shadow-glow border-turquoise">
          <header className="text-center">
            <h1 className="text-3xl md:text-5xl font-bold headline-contrast text-headline-strong">Join Our WhatsApp Groups</h1>
            <p className="text-muted-foreground mt-4 text-base md:text-lg">Select your preferred group below and tap to join</p>
          </header>

          {/* Jobs Section */}
          <div className="mt-12 w-full">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-turquoise mb-2">{whatsappGroups.jobs.title}</h2>
              <p className="text-sm md:text-base text-muted-foreground">{whatsappGroups.jobs.description}</p>
            </div>
            <div className="flex flex-col items-center space-y-6 mb-10">
              {whatsappGroups.jobs.groups.map((g) => (
                <div key={g.id} className="w-full max-w-xl">
                  <LinkTreeCard
                    title={g.title}
                    description={g.description}
                    href={g.url}
                    buttonText={g.buttonText}
                    icon={<MessageCircle className="w-5 h-5 text-white" />}
                  />
                  {g.metadata && (
                    <div className="mt-3 px-4 py-3 rounded-lg bg-card/50 border border-maroon/30">
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs">
                        <div>
                          <p className="text-muted-foreground">Members</p>
                          <p className="font-semibold text-white">{g.metadata.members}</p>
                        </div>
                        <div>
                          <p className="text-muted-foreground">Category</p>
                          <p className="font-semibold text-white">{g.metadata.category}</p>
                        </div>
                        <div>
                          <p className="text-muted-foreground">Updates</p>
                          <p className="font-semibold text-white">{g.metadata.updateFrequency}</p>
                        </div>
                        <div>
                          <p className="text-muted-foreground">Featured</p>
                          <p className="font-semibold text-turquoise text-[11px]">{g.metadata.featured[0]}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Training Section */}
          <div className="mt-12 w-full border-t border-turquoise pt-10">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-turquoise mb-2">{whatsappGroups.training.title}</h2>
              <p className="text-sm md:text-base text-muted-foreground">{whatsappGroups.training.description}</p>
            </div>
            <div className="flex flex-col items-center space-y-6">
              {whatsappGroups.training.groups.map((g) => (
                <div key={g.id} className="w-full max-w-xl">
                  <LinkTreeCard
                    title={g.title}
                    description={g.description}
                    href={g.url}
                    buttonText={g.buttonText}
                    icon={<MessageCircle className="w-5 h-5 text-white" />}
                  />
                  {g.metadata && (
                    <div className="mt-3 px-4 py-3 rounded-lg bg-card/50 border border-maroon/30">
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs">
                        <div>
                          <p className="text-muted-foreground">Members</p>
                          <p className="font-semibold text-white">{g.metadata.members}</p>
                        </div>
                        <div>
                          <p className="text-muted-foreground">Category</p>
                          <p className="font-semibold text-white">{g.metadata.category}</p>
                        </div>
                        <div>
                          <p className="text-muted-foreground">Updates</p>
                          <p className="font-semibold text-white">{g.metadata.updateFrequency}</p>
                        </div>
                        <div>
                          <p className="text-muted-foreground">Featured</p>
                          <p className="font-semibold text-turquoise text-[11px]">{g.metadata.featured[0]}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
